// Deve restare allineato a MetodoPagamento in
// G.M.Portal_server_v2/app/database/enums.py
export const METODI_PAGAMENTO = [
  { value: 1, nome: "Contanti" },
  { value: 2, nome: "Bonifico" },
  { value: 3, nome: "Assegno" },
  { value: 4, nome: "POS" },
  { value: 5, nome: "Sepa DirectDebit" }, // ex RID: stesso valore numerico, solo rinominato
  { value: 7, nome: "Ri.Ba" },
  { value: 6, nome: "Altro" },
];

export function nomeMetodoPagamento(value) {
  const metodo = METODI_PAGAMENTO.find((m) => m.value === value);
  return metodo ? metodo.nome : null;
}
